<template>
  <div class="agency-search-input">

    <label v-if="!!label">{{ label + ( isMandatory ? ' *' : '') }}</label>
    <agency-search
      class="full"
      :placeholder="placeholder"
      :defaultSearchTerm="value"
      v-model="value"
      v-on:change="onInput"
      @selectedResult="selectedResult"
      :class="[ isError ? 'error' : '']"
    />
    <span v-if="isError" id="error-message" class="error inline">
      {{ errorMsg }}
    </span>
  </div>
</template>

<script>

import AgencySearch from '@/components/Forms/AgencySearch.vue';

export default {
  name: 'AgencySearchInput',
  props: {
    label: {
      required: true,
    },
    isMandatory: {
      default: false,
    },
    placeholder: {
      default: '',
    },
    default: {
      default: {},
    },
  },
  components: {
    AgencySearch,
  },
  computed: {
    isError() {
      return this.errorMsg !== '';
    },
    isEmpty() {
      return !this.value || this.value.trim() === '';
    },
    noResultSelected() {
      return this.select === null;
    },
    valuesObject() {
      return {
        select: this.select,
        value: this.value,
        error: this.isError,
        label: this.label,
      };
    },
  },
  created() {
    this.$parent.$on('validate-fields', this.validate);
  },
  data() {
    return {
      errorMsg: '',
      value: this.default !== {} ? this.default.fullname : '',
      select: this.default !== {} ? this.default : null,
    };
  },
  methods: {
    validate() {
      this.errorMsg = '';

      if (this.isMissingInput()) {
        this.errorMsg = 'Please search for your agency.';
      }

      if (this.isMissingSelectedResult()) {
        this.errorMsg = 'Please select your agency from the results.';
      }

      this.$emit('validated-fields', this.valuesObject);
    },
    isMissingInput() {
      return this.isMandatory && this.isEmpty;
    },
    isMissingSelectedResult() {
      return !this.isMissingInput() && this.noResultSelected;
    },
    onInput() {
      this.select = null;
      this.$emit('input', this.valuesObject);
    },
    selectedResult(result) {
      this.select = result;
    },
  },
};
</script>

<style lang="scss" scoped>

label {
  @apply ut-font-bold ut-text-sm ut-pb-3 ut-tracking-normal;
  line-height: 24px;
}

.full {
  display: inline-block;
  @apply ut-w-full;
}

.first {
  display: inline-block;
  @apply ut-w-full;
  @screen md {
    width: 58%;
  }
  margin-right: 10px;
}

.second {
  display: inline-block;
  @apply ut-w-full;
  @screen md {
    width: 40%;
  }
}

.half {
  display: inline-block;
  width: 50%;
}

.half.first {
  width: 48%;
  margin-right: 5px;
}

</style>
